export var AnalyticsEventPatterns;
(function (AnalyticsEventPatterns) {
    AnalyticsEventPatterns["ANALYTICS_ERROR"] = "ANALYTICS_ERROR";
})(AnalyticsEventPatterns || (AnalyticsEventPatterns = {}));
//# sourceMappingURL=analytics-event-patterns.enum.js.map